import { z } from "zod";

export type IModuleID = z.infer<typeof TModuleID>;
export const TModuleID = z.enum([
  "activities",
  "booking",
  "branding",
  "chats",
  "checklistTemplates",
  "collections",
  "contractors",
  "costs",
  "customAppSettings",
  "customDashboards",
  "customCollections",
  "customDataTypes",
  "deviations",
  "digitalKeys",
  "documentAI",
  "documentAIClassification",
  "events",
  "fire",
  "globalCollections",
  "incomeOverview",
  "insights",
  "maintenanceReports",
  "posts",
  "reports",
  "routines",
  "sensorData",
  "smsNotifications",
  "spreadsheet",
  "surveys",
  "tenantEconomy",
  "timeTracking",
  "workflows",
]);

export type ICompanyModule = z.infer<typeof TCompanyModule>;
export const TCompanyModule = z.object({
  active: z.boolean(),
  allProperties: z.boolean(),
  selectedProperties: z.array(z.string()).optional(),
});

export type IPropertyModule = z.infer<typeof TPropertyModule>;
export const TPropertyModule = z.object({
  active: z.boolean(),
  units: z.array(z.string()).optional(),
});
